import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Services from '../../services/service';
import {BASE_URL} from '../../config/constants';
import LayoutMapper from '../../components/LayoutMapper/LayoutMapper.component';

class BuildingZoneLayout extends Component {

  constructor(props){
    super(props);
    this.state = {
      layoutData: [],
      showModalPreview: false,
      selectedLayout: null,
    };
    this.initialState = this.state;
  }

  componentDidMount(){
    this.getZoneLayout();
  }

  getZoneLayout = () => {
    Services.getZoneLayout()
      .then(res => {
        this.setState({ layoutData: res })
      })
      .catch(err => console.log(err))
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">Building Zone Layout</li>
      </ol>
      <h1 className="page-header">Building Zone Layout</h1>
    </div>
  );

  renderLayout = () => {
    return (
      <div id="gallery" className="gallery">
        {this.state.layoutData.map((layout, idx) =>{
          return(
            <div className={'image pull-left'} key={idx}>
              <div className="image-inner">
                {/* <Link to="/gallery"> */}
                  <img 
                    src={`${BASE_URL}/layout-zone-file/${layout.file}`} 
                    alt={layout.name}
                    onClick={() => this.togglePreviewLayout(layout)}
                    style={{cursor: 'pointer'}} 
                  />
                {/* </Link> */}
                <p className="image-caption">
                  #{layout.code} - {layout.name}
                </p>
              </div>
              <div className="image-info">
                <h5 className="title">{layout.building} - {layout.floor}</h5>
                <div className="desc">
                  {layout.buildingAddress}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    )
  };

  togglePreviewLayout = (layout) =>{
    this.setState({
      showModalPreview: !this.state.showModalPreview,
      selectedLayout: layout? layout: null,
    });
  }

  renderModalPreviewLayout = () =>{
    const headerText = `${this.state.selectedLayout.name} - ${this.state.selectedLayout.building} - ${this.state.selectedLayout.floor}`;
    return (
      <Modal size='xl' isOpen={this.state.showModalPreview} toggle={() => this.togglePreviewLayout()}>
        <ModalHeader toggle={() => this.togglePreviewLayout()}>{headerText}</ModalHeader>
        <ModalBody>
          <LayoutMapper selectedLayout={this.state.selectedLayout._id}/>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.togglePreviewLayout()}>Tutup</button>
        </ModalFooter>
      </Modal>
    )
  }

  render() {
    return (
      <div>
        {this.renderBreadcrumb()}
        {this.renderLayout()}
        {this.state.showModalPreview &&
          this.renderModalPreviewLayout()
        }
      </div>
    )
  }
}

export default BuildingZoneLayout
